module.exports = __webpack_public_path__ + "static/KC7-87f44b74281cc3d2951675bb70d3d08b.png";